<template><div>
    <div class="form-group row">
        <label for="device" class="col-md-4 col-form-label text-md-right">
            {{ t.fields.current_location }}
        </label>
        <div class="col-md-6">
            <select id="device" name="current_device" class="form-control" v-model="selected_location">
                <option v-for="o in location_options" :value="o.value" :selected="o.value === selected_location">{{ o.display }}</option>
            </select>
        </div>
    </div>
    <div class="form-group row" id="deployment-time-group" v-if="selected_location == (current_location ? current_location.id : 'new-location')">
        <label for="location-name" class="col-md-4 col-form-label text-md-right">
            {{ t.fields.location_name }}
        </label>
        <div class="col-md-6">
            <input id="location-name" name="location-name" type="text" class="form-control" v-bind:class="{ 'is-invalid': timestampHasError()}" v-model="location_name" required/>

            <span class="invalid-feedback" role="alert" v-if="timestampHasError()">
                <strong v-for="m in [].concat(errors['deployment-timestamp.date'], errors['deployment-timestamp.time'], errors['deployment'])">
                    {{ m }}
                </strong>
            </span>
        </div>
    </div>
</div>
</template>

<script>
    import idx from 'idx'
    export default {
        props: ['t', 'location_options', 'current_location', 'errors', 'old'],
        data() {
            const d = new Date()
            return {
                selected_location: 'current_location' in this.old ? (this.old.current_location || '') : (idx(this.current_location, _ => _.id) || ''),
                location_name: 'location_name' in this.old ? (this.old.location_name || '') : (idx(this.location_name, _ => _.id) || ''),

            }
        },
        methods: {
            timestampHasError() {
                return 'deployment-timestamp.date' in this.errors || 'deployment-timestamp.time' in this.errors || 'deployment' in this.errors
            },
        }
    }
</script>

<style scoped>

</style>
